require.register("ffss/ui/modal/Confirm", function(exports, require, module){
  $0
  
});

